import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddLineIcon from 'remixicon-react/AddLineIcon';
import RenderPlayistArticles from './RenderPlayistArticles';
import AddPostsToPlaylistModal from './AddPostsToPlaylistModal';
import { ArticleSourceType, ArticleType } from '../hooks/useArticlesQuery';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { PostFormData } from 'pages/addPost/hooks/useAddPostForm';
import _ from 'lodash';
import { useBuildWiseModules } from '@buildwise/libs/helpers';

const RenderPostsInEditPlayListModal: React.FC<{
  playListArticles: ArticleType[];
  article: ArticleType;
  openAddArticlesModal?: boolean;
  getValues: UseFormGetValues<PostFormData>;
  setValue: UseFormSetValue<PostFormData>;
  setOpenAddArticlesModal?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  playListArticles,
  article,
  openAddArticlesModal,
  getValues,
  setValue,
  setOpenAddArticlesModal,
}) => {
  const [openAddPostsToPlaylistModal, setAddPostsToPlaylistModalOpen] = useState(false);
  const [duplicatePlayListArticles, setDuplicatePlayListArticles] =
    useState<ArticleType[]>(playListArticles);
  const { singularCollectionsModuleName } = useBuildWiseModules();
  useEffect(() => {
    setDuplicatePlayListArticles(playListArticles);
  }, [playListArticles]);

  const addToPlayListArticles = (playListArticle: ArticleType[]) => {
    const copyPlayListArticles = (getValues()?.playListArticles || []) as ArticleType[];
    const concatenatedResult = _.uniqBy(copyPlayListArticles.concat(playListArticle), 'id');
    setDuplicatePlayListArticles([...concatenatedResult]);
    const playListArticleIds = getValues()?.playListArticleIds || [];
    const newPlayListArticleIds = playListArticle.map((playlist) => playlist.id);
    setValue?.('playListArticleIds', _.uniq([...playListArticleIds, ...newPlayListArticleIds]), {
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue?.('playListArticles', concatenatedResult, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ fontWeight: 700, color: 'black' }}>
          {article?.articleType === ArticleSourceType.HELP_CENTER
            ? 'Help Articles in this'
            : ' Posts in this'}{' '}
          {singularCollectionsModuleName}
        </Typography>
        <Box>
          <Button
            startIcon={<AddLineIcon />}
            variant="outlined"
            onClick={() => setAddPostsToPlaylistModalOpen(true)}
            sx={{ mt: 2 }}
          >
            {article?.articleType === ArticleSourceType.HELP_CENTER ? 'Add Articles' : 'Add Posts'}
          </Button>
        </Box>
      </Box>

      {duplicatePlayListArticles?.length > 0 && (
        <RenderPlayistArticles
          posts={duplicatePlayListArticles}
          getValues={getValues}
          setValue={setValue}
          draggable
        />
      )}

      {(openAddPostsToPlaylistModal || openAddArticlesModal) && (
        <AddPostsToPlaylistModal
          open={openAddPostsToPlaylistModal || !!openAddArticlesModal}
          setOpen={(flag: boolean) => {
            setAddPostsToPlaylistModalOpen(flag);
            setOpenAddArticlesModal?.(flag);
          }}
          playListArticle={article}
          isEdit={true}
          addToPlayListArticles={addToPlayListArticles}
          getValues={getValues}
        />
      )}
    </>
  );
};

export default RenderPostsInEditPlayListModal;
